export default {
    data: () => {
        return {
            windowWidth: window.innerWidth,
            breakpoints: {
                xs: 0,
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
                xxl: 1400
            }
        }
    },
    methods: {
        getBreakpoint(){
            const windowWidth = window.innerWidth;
            if(windowWidth >= this.breakpoints.xxl)
                return 'xxl';
            else if(windowWidth >= this.breakpoints.xl)
                return 'xl';
            else if(windowWidth >= this.breakpoints.lg)
                return 'lg';
            else if(windowWidth >= this.breakpoints.md)
                return 'md';
            else if(windowWidth >= this.breakpoints.sm)
                return 'sm';
            else
                return 'xs';
        },
        isBreakpoint(breakpoint = 'sm'){
            return this.getBreakpoint() === breakpoint;
        }
    }
}
